/**
 * Bandit tallennetaan metreinä (REAL), esim. 160, 20, 2, 0.7 (= 70 cm).
 * Pyöristetään aina kahteen desimaaliin, jotta vertailut pysyvät tarkkoina.
 */
export function roundBand(value: number): number {
  return Math.round(value * 100) / 100;
}

/** Tulkitsee bandin ADIF-/käyttäjäsyötteestä: "20m", "20", "70cm", "0,7", "2M" */
export function parseBand(input: string | number | null | undefined): number | null {
  if (input === null || input === undefined) return null;
  if (typeof input === 'number') return Number.isFinite(input) && input > 0 ? roundBand(input) : null;
  let s = input.trim().toLowerCase().replace(',', '.');
  if (!s) return null;
  let factor = 1;
  if (s.endsWith('mm')) {
    factor = 0.001;
    s = s.slice(0, -2);
  } else if (s.endsWith('cm')) {
    factor = 0.01;
    s = s.slice(0, -2);
  } else if (s.endsWith('m')) {
    s = s.slice(0, -1);
  }
  const n = Number(s.trim());
  if (!Number.isFinite(n) || n <= 0) return null;
  return roundBand(n * factor);
}

/** Näyttömuoto: 160 → "160", 0.7 → "70 cm", 2.5 → "2,5" */
export function formatBand(band: number): string {
  if (band < 1) return `${Math.round(band * 100)} cm`;
  return String(roundBand(band)).replace('.', ',');
}

const BAND_PLAN: Array<[number, number, number]> = [
  // [min MHz, max MHz, band (m)]
  [1.8, 2.0, 160],
  [3.5, 4.0, 80],
  [5.06, 5.45, 60],
  [7.0, 7.3, 40],
  [10.1, 10.15, 30],
  [14.0, 14.35, 20],
  [18.068, 18.168, 17],
  [21.0, 21.45, 15],
  [24.89, 24.99, 12],
  [28.0, 29.7, 10],
  [50.0, 54.0, 6],
  [70.0, 71.0, 4],
  [144.0, 148.0, 2],
  [420.0, 450.0, 0.7],
];

/** Päättelee bandin taajuudesta (MHz), jos ADIF-tiedostossa ei ole band-kenttää */
export function bandFromFrequency(mhz: number | null | undefined): number | null {
  if (!mhz || !Number.isFinite(mhz)) return null;
  for (const [min, max, band] of BAND_PLAN) {
    if (mhz >= min && mhz <= max) return band;
  }
  return null;
}

/** "2011-10-14" → "14.10.2011" */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return iso;
  return `${Number(m[3])}.${Number(m[2])}.${m[1]}`;
}

/** "2011-10-14 10:54:38" → "14.10.2011 10:54" */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(iso);
  if (!m) return formatDate(iso);
  return `${Number(m[3])}.${Number(m[2])}.${m[1]} ${m[4]}:${m[5]}`;
}

/** Kutsutunnus normalisoituna: isot kirjaimet, ei välilyöntejä */
export function normalizeCall(call: string): string {
  return call.trim().toUpperCase().replace(/\s+/g, '');
}
